import React from 'react';

import Teaser from "../components/Teaser";
import FormContainer from '../components/FormContainer';
import ConfirmationMessage from "../components/ConfirmationMessage";
import SubmissionMessage from "../components/SubmissionMessage";

class Form extends React.Component {
    state = {
        formVisible: true,
        submissionVisible: false,
        confirmationVisible: false,
        teaser: Teaser.chooseTeaser()
    };

    showSubmissionMessage = () => {
        this.setState({
            formVisible: false,
            confirmationVisible: false,
            submissionVisible: true
        });
    };

    showConfirmationMessage = () => {
        this.setState({
            formVisible: false,
            confirmationVisible: true,
            submissionVisible: false
        });
    };

    render() {
        return (

            <div className={"wrap"}>

                <header>
                    <a href="https://www.stadtbranchenbuch.com/" target="_blank" rel="noopener noreferrer">
                        <img src={require('../images/stadtbranchenbuch_logo.png')} alt="opendi.com logo"
                             className="logo"/>
                    </a>
                </header>

                <main style={{backgroundImage: `url(${this.state.teaser.image})`}}>

                    <Teaser teaser={this.state.teaser}/>

                    <div className={"frame row"}>

                        <div className={"col-md-5 col-11 "}>
                            <div className={"sidebar"}>
                                <h1><i className={"lni-map-marker"}/> Ihr kostenloser Firmeneintrag </h1>
                                <ul>
                                    <li><i className={"lni-check-mark-circle"}/> auf 2 Portalen: stadtbranchenbuch.com und 11880.com</li>
                                    <li><i className={"lni-check-mark-circle"}/> schnell &uuml;ber 3 Mio. Besucher
                                        monatlich erreichen
                                    </li>
                                    <li><i className={"lni-check-mark-circle"}/> einfach gefunden werden</li>
                                    <li><i className={"lni-check-mark-circle"}/> seri&ouml;s Ihren Kundenstamm erweitern
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className={"form col-md-6 col-11"}>
                            <FormContainer
                                isVisible={this.state.formVisible}
                                showSubmissionMessage={this.showSubmissionMessage}
                                showConfirmationMessage={this.showConfirmationMessage}
                                ga={this.props.ga}
                            />
                            <SubmissionMessage isVisible={this.state.submissionVisible} ga={this.props.ga} />
                            <ConfirmationMessage isVisible={this.state.confirmationVisible} ga={this.props.ga} />
                        </div>
                    </div>

                </main>

                <footer>
                    <a href="https://www.stadtbranchenbuch.com/content/impressum.html">Impressum </a> | <a
                    href="https://www.stadtbranchenbuch.com/content/datenschutz.html">Datenschutz</a>
                </footer>

            </div>

        );
    }
}

export default Form;
